import { render, staticRenderFns } from "./LessonTextContent.vue?vue&type=template&id=4bf1f0a8&"
import script from "./LessonTextContent.vue?vue&type=script&lang=js&"
export * from "./LessonTextContent.vue?vue&type=script&lang=js&"
import style0 from "./LessonTextContent.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LessonTextContent.vue"
export default component.exports